import { handleActions } from 'redux-actions';
import { assoc, mergeLeft } from 'ramda';

import {
  resourcesInitializeComplete,
  requestResourcesSuccess,
  resourcesLoadData,
  resourcesLoadDataSuccess,
  requestGetResourceImageSuccess,
  requestGetResourceFileSuccess,
  resourcesResetFiles,
  resourcesInitialize,
  requestGetPatientsResourcesStatusesSuccess,
  resourcesSetStatuses,
  resourcesChangeStatuses,
  resourcesChangeStatusesComplete,
  requestResourcesFaqSuccess,
} from 'store/actionCreators/resources';

const defaultState = {
  faq: null,
  currentResource: null,
  resourceImg: null,
  resourceFile: null,
  statuses: null,
  isStatusesInChange: false,
  loading: true,
  data: null,
};

export default handleActions(
  {
    [resourcesInitialize]: state => assoc('loading', true, state),
    [resourcesInitializeComplete]: state => assoc('loading', false, state),

    [requestResourcesSuccess]: (state, { payload: { response } }) => assoc('data', response, state),
    [requestResourcesFaqSuccess]: (state, { payload: { response } }) =>
      assoc('faq', response, state),

    [requestGetPatientsResourcesStatusesSuccess]: (state, { payload: { response } }) =>
      assoc('statuses', response, state),

    [resourcesLoadData]: state => assoc('loading', true, state),
    [resourcesSetStatuses]: (state, { payload: { statuses } }) =>
      assoc('statuses', statuses, state),
    [resourcesChangeStatuses]: state => assoc('isStatusesInChange', true, state),
    [resourcesChangeStatusesComplete]: state => assoc('isStatusesInChange', false, state),

    [requestGetResourceImageSuccess]: (state, { payload: { response } }) =>
      assoc('resourceImg', response, state),
    [requestGetResourceFileSuccess]: (state, { payload: { response } }) =>
      assoc('resourceFile', response, state),
    [resourcesLoadDataSuccess]: (state, { payload: { resourceId } }) =>
      mergeLeft({ currentResource: resourceId, loading: false }, state),
    [resourcesResetFiles]: state => mergeLeft({ resourceImg: null, resourceFile: null }, state),
  },
  defaultState,
);
